"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }










// The muted text beside a suggestion. Most chats are within one org, so the
// org name is added only for people and teams from another org.
 const mentionDetails = (parts, orgName, isExternal) =>
  [...parts, isExternal ? orgName : undefined].filter(Boolean).join(' · '); exports.mentionDetails = mentionDetails




























// Who can be @mentioned in a chat: its teams, its people (plus the members of
// same-org teams), its patients, and @all once more than two staff are in it.
 const buildMentionCandidates = ({
  userSubscribers, teamSubscribers, patientSubscribers, users, teams, patients, myOrgKey, myUserKey, orgName, isNewChat,
}) => {
  const isExternal = (orgKey) => !!orgKey && orgKey !== myOrgKey
  const personSecondary = (user, orgKey) =>
    exports.mentionDetails.call(void 0, [orgKey && _optionalChain([user, 'access', _ => _.Relationships, 'optionalAccess', _2 => _2[orgKey], 'optionalAccess', _3 => _3.Title])], orgKey && orgName(orgKey), isExternal(orgKey))
  const person = (key, orgKey) => {
    const user = _optionalChain([users, 'optionalAccess', _4 => _4[key]])
    return user && key !== myUserKey ? [{ Kind: 'user', TargetKey: key, DisplayName: user.Name, Secondary: personSecondary(user, orgKey) }] : []
  }
  const teamKeys = Object.keys(teamSubscribers)
  const subscriberKeys = Object.keys(userSubscribers)
  const allStaffKeys = new Set(subscriberKeys)
  const viaTeam = new Map()
  const teamCandidates = teamKeys.flatMap((key) => {
    const team = _optionalChain([teams, 'optionalAccess', _5 => _5[key]])
    if (!team) return []
    const memberKeys = Object.keys(team.Members || {})
    memberKeys.forEach(memberKey => {
      if (!isNewChat || !isExternal(team.OrgKey)) allStaffKeys.add(memberKey)
      if (!isExternal(team.OrgKey) && !userSubscribers[memberKey] && !viaTeam.has(memberKey)) viaTeam.set(memberKey, team.OrgKey)
    })
    return [{
      Kind: 'team',
      TargetKey: key,
      DisplayName: team.Name,
      Secondary: exports.mentionDetails.call(void 0, [`${memberKeys.length} members`], team.OrgKey && orgName(team.OrgKey), isExternal(team.OrgKey)),
      MemberCount: memberKeys.length,
    }]
  })
  const people = [
    ...subscriberKeys.flatMap(key => person(key, _optionalChain([userSubscribers, 'access', _6 => _6[key], 'optionalAccess', _7 => _7.OrgKey]))),
    ...[...viaTeam].flatMap(([key, orgKey]) => person(key, orgKey)),
  ]
  const patientCandidates = Object.keys(patientSubscribers).flatMap((key) => {
    const patient = _optionalChain([patients, 'optionalAccess', _8 => _8[key]])
    return patient ? [{ Kind: 'patient', TargetKey: key, DisplayName: patient.Name, Secondary: 'Patient' }] : []
  })
  if (myUserKey && isNewChat) allStaffKeys.delete(myUserKey)
  const everyone = allStaffKeys.size > (isNewChat ? 1 : 2)
  return [
    ...teamCandidates,
    ...people,
    ...patientCandidates,
    ...(everyone ? [{ Kind: 'all' , DisplayName: 'all', Secondary: 'Everyone in this conversation' }] : []),
  ]
}; exports.buildMentionCandidates = buildMentionCandidates

const MENTION_AVATAR_TINTS = [
  { backgroundColor: '#e8e4fb', color: '#5a4fc0' }, { backgroundColor: '#dff3ee', color: '#1f7a66' },
  { backgroundColor: '#fde9e1', color: '#b0512b' }, { backgroundColor: '#e3eefb', color: '#2f63a8' },
  { backgroundColor: '#f7e6f3', color: '#9a3a82' }, { backgroundColor: '#fbf1d9', color: '#8a6512' },
]

// A stable avatar tint per person, the same on web and mobile (FNV-1a spreads similar keys).
 const mentionAvatarTint = (key) =>
  MENTION_AVATAR_TINTS[Array.from(key).reduce((h, c) => Math.imul(h ^ c.charCodeAt(0), 16777619) >>> 0, 2166136261) % MENTION_AVATAR_TINTS.length]; exports.mentionAvatarTint = mentionAvatarTint









// JS string offsets are UTF-16 code units, matching the backend contract and
// browser/React Native selection APIs.
 const splitTextWithMentions = (text, mentions) => {
  if (!_optionalChain([mentions, 'optionalAccess', _9 => _9.length])) return [{ text, start: 0 }]
  const valid = mentions
    .filter(m => Number.isInteger(m.Start) && Number.isInteger(m.End) && m.Start >= 0 && m.End > m.Start && m.End <= text.length)
    .sort((a, b) => a.Start - b.Start)
  const segments = []
  let cursor = 0
  for (const mention of valid) {
    if (mention.Start < cursor) continue
    if (mention.Start > cursor) segments.push({ text: text.slice(cursor, mention.Start), start: cursor })
    segments.push({ text: mention.ResolvedDisplayText || text.slice(mention.Start, mention.End), start: mention.Start, mention })
    cursor = mention.End
  }
  if (cursor < text.length || segments.length === 0) segments.push({ text: text.slice(cursor), start: cursor })
  return segments
}; exports.splitTextWithMentions = splitTextWithMentions

 const filterMentionCandidates = (candidates, query) => {
  const normalized = query.trim().toLocaleLowerCase()
  if (!normalized) return candidates
  return candidates.filter(candidate =>
    candidate.DisplayName.toLocaleLowerCase().includes(normalized) ||
    _optionalChain([candidate, 'access', _10 => _10.Secondary, 'optionalAccess', _11 => _11.toLocaleLowerCase, 'call', _12 => _12(), 'access', _13 => _13.includes, 'call', _14 => _14(normalized)]),
  )
}; exports.filterMentionCandidates = filterMentionCandidates

// The picker has a single canonical order so its visual row, keyboard index,
// and tap target always resolve to the same identity: teams, @all, then people.
 const getVisibleMentionCandidates = (candidates, query, limit = 20) => {
  const filtered = exports.filterMentionCandidates.call(void 0, candidates, query)
  const teams = filtered.filter(candidate => candidate.Kind === 'team')
  const everyone = filtered.filter(candidate => candidate.Kind === 'all')
  const people = filtered.filter(candidate => candidate.Kind !== 'team' && candidate.Kind !== 'all')
  return [...teams, ...everyone, ...people].slice(0, limit)
}; exports.getVisibleMentionCandidates = getVisibleMentionCandidates

 const mentionText = (candidate, start) => ({
  Kind: candidate.Kind,
  TargetKey: candidate.TargetKey,
  DisplayText: `@${candidate.DisplayName}`,
  Start: start,
  End: start + `@${candidate.DisplayName}`.length,
}); exports.mentionText = mentionText

// Preserve picked spans through a single textarea edit. JavaScript string
// indices are UTF-16 units, so the prefix/suffix walk uses the same offsets as
// the message wire contract. Mentions touched by an edit are dropped and fall
// back to their readable text until the user picks them again.
//
// The text alone cannot say where an edit happened inside repeated text
// (deleting the first of two identical pills looks like deleting the second).
// `editStart` is an offset the edit cannot start after, such as the caret;
// it keeps the edit, and the dropped mention, where the user actually typed.
 const reconcileMentions = (
  before,
  after,
  mentions,
  editStart = Infinity,
) => {
  if (!mentions.length) return []
  const prefixLimit = Math.max(0, Math.min(before.length, after.length, editStart))
  let prefix = 0
  while (prefix < prefixLimit && before[prefix] === after[prefix]) prefix++
  let beforeSuffix = before.length
  let afterSuffix = after.length
  while (beforeSuffix > prefix && afterSuffix > prefix && before[beforeSuffix - 1] === after[afterSuffix - 1]) {
    beforeSuffix--
    afterSuffix--
  }
  const delta = afterSuffix - beforeSuffix
  return mentions
    .filter(mention => mention.End <= prefix || mention.Start >= beforeSuffix)
    .map(mention => mention.Start >= beforeSuffix
      ? { ...mention, Start: mention.Start + delta, End: mention.End + delta }
      : mention)
    .filter(mention => mention.Start >= 0 && mention.End <= after.length && after.slice(mention.Start, mention.End) === mention.DisplayText)
}; exports.reconcileMentions = reconcileMentions

// Mirror of the backend's `printable,trim` chain (validate.IsPrintable, then
// strings.TrimSpace). Go's unicode.IsPrint rejects control (Cc), format (Cf),
// private-use (Co) and unassigned runes; IsSpace re-admits whitespace, and the
// backend explicitly keeps the zero-width space/joiners and U+FEFF. Unassigned
// runes are left alone: JS and Go ship different Unicode versions, and the
// server remaps spans for anything it drops that we kept. Every other
// exemption was checked rune by rune against the Go filter (gomoji included):
// it keeps exactly these Cc/Cf/Co runes and drops the rest, emoji tag
// characters among them.
// This is deliberately separate from sanitizationRegExp, which also cleans
// search queries and form fields.
const serverDroppedRune = /^(?![\t\n\v\f\r\u0085\u200B-\u200D\uFEFF])[\p{Cc}\p{Cf}\p{Co}]$/u
// Go's unicode.IsSpace set. Unlike String.prototype.trim it includes U+0085
// and excludes U+FEFF.
const goSpace = '[\\t\\n\\v\\f\\r \\u0085\\u00A0\\u1680\\u2000-\\u200A\\u2028\\u2029\\u202F\\u205F\\u3000]'
const leadingGoSpace = new RegExp(`^${goSpace}+`)
const trailingGoSpace = new RegExp(`${goSpace}+$`)

// The API removes non-printable runes and then trims message text. Keep the
// UTF-16 mention coordinates in lockstep with that transformation so a span
// selected before sending still points at the same readable token on the wire.
 const normalizeMessageWithMentions = (text, mentions = []) => {
  let cleaned = ''
  const map = new Array(text.length + 1)
  let sourceOffset = 0
  for (const rune of Array.from(text)) {
    for (let i = 0; i < rune.length; i++) map[sourceOffset + i] = cleaned.length
    if (!serverDroppedRune.test(rune)) cleaned += rune
    sourceOffset += rune.length
  }
  map[sourceOffset] = cleaned.length
  const leading = _nullishCoalesce(_optionalChain([cleaned, 'access', _15 => _15.match, 'call', _16 => _16(leadingGoSpace), 'optionalAccess', _17 => _17[0], 'access', _18 => _18.length]), () => ( 0))
  const resultText = cleaned.slice(leading).replace(trailingGoSpace, '')
  const normalized = mentions.map(mention => {
    const start = Math.max(0, (_nullishCoalesce(map[mention.Start], () => ( mention.Start))) - leading)
    const end = Math.min(resultText.length, Math.max(start, (_nullishCoalesce(map[mention.End], () => ( mention.End))) - leading))
    return { ...mention, Start: start, End: end, DisplayText: resultText.slice(start, end) }
  }).filter(mention => mention.End > mention.Start && resultText.slice(mention.Start, mention.End).startsWith('@'))
  return { text: resultText, mentions: normalized }
}; exports.normalizeMessageWithMentions = normalizeMessageWithMentions
